import { render, staticRenderFns } from "./HomeFreightCalc.vue?vue&type=template&id=5876fae5"
import script from "./HomeFreightCalc.vue?vue&type=script&lang=js"
export * from "./HomeFreightCalc.vue?vue&type=script&lang=js"
import style0 from "./HomeFreightCalc.vue?vue&type=style&index=0&id=5876fae5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports